import type { MailboxInfo } from 'owa-client-types';
import { getAsyncItemRegistry } from './getAsyncItemRegistry';
import type { AsyncItemEntry } from '../store/schema/AsyncItemEntry';

/** Returns the tracked async item for an id, if any. */
export function getAsyncItemEntry(
    mailboxInfo: MailboxInfo,
    id: string
): AsyncItemEntry | undefined {
    return getAsyncItemRegistry(mailboxInfo)?.entriesById.get(id);
}
